import React from "react";
import textConfig from "../utils/text";

/**
 * Frame 21
 * @param props
 * @constructor
 */
export default function Frame21(props: any){
	let {  Svg, svgProps, children, viewBox, frameBody } = props;
	let { path, text_1 } = props, [ __html, { textColor, style } ] = textConfig(text_1, frameBody);
	
	return <Svg xmlns="http://www.w3.org/2000/svg" {...svgProps} viewBox="0 0 1154 1318.637">
		<defs>
			<clipPath id="myClip">
				<rect width="1000" height="1200" rx={30} fill={'none'}/>
			</clipPath>
		</defs>
		
		<g transform={"translate(154 0)"}>
			<g clipPath="url(#myClip)">{children}</g>
		</g>
		<g transform="translate(0 838)">
			<path d="M153.314,90.1,0,159.506H153.314Z" transform="translate(0 0)" fill={frameBody}/>
			<path d="M153.314,90.1,0,159.506H153.314Z" transform="translate(0 0)" fill="#fff" opacity="0.3"/>
			<path d="M0,96.9V392.133H0A24.862,24.862,0,0,0,24.862,417H1129.138A24.862,24.862,0,0,0,1154,392.133h0V96.9Z"
			      transform="translate(0 63.642)" fill={frameBody}/>
		</g>
		<g transform="translate(150 2)">
			<rect width="1000" height="1200" rx={30} fill={'none'} stroke={frameBody} strokeWidth="8"/>
		</g>
		<g transform={"translate(220 1080) scale(0.85)"}>
			<svg xmlns="http://www.w3.org/2000/svg" width={1000} height={200} viewBox={viewBox}>
				<defs>
					<clipPath id="myClip">
						<path d={path}/>
					</clipPath>
				</defs>
				<foreignObject x="0" y="0" width="1000" height="200" clipPath="url(#myClip)">
					<div
						dangerouslySetInnerHTML={{__html}}
						style={{
							width: 'calc(100%)', height: 'calc(100%)',
							display: 'flex', justifyContent: 'center', alignItems: 'center',
							...style, color: textColor
						}}
					/>
				</foreignObject>
			</svg>
		</g>
	</Svg>
}